var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledSeventeen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.2546V36.3134C0 36.9628 0.527059 37.4899 1.17647 37.4899H3.68549V29.4115C3.68549 28.762 4.21255 28.235 4.86196 28.235C5.51216 28.235 6.03843 28.762 6.03843 29.4115V37.4899H10.0392V20.0781H1.17647C0.527059 20.0781 0 20.6052 0 21.2546Z",
    fill: "#D2AE5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 29.9609H22.5905V37.4904H17.4141V29.9609Z",
    fill: "#D2AE5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8237 20.0781H29.9609V37.4899H33.9617V29.4115C33.9617 28.7613 34.488 28.235 35.1382 28.235C35.7876 28.235 36.3147 28.7613 36.3147 29.4115V37.4899H38.8237C39.4731 37.4899 40.0002 36.9628 40.0002 36.3134V21.2546C40.0002 20.6052 39.4731 20.0781 38.8237 20.0781Z",
    fill: "#D2AE5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9185 17.4118C33.0302 17.4118 33.5218 16.0022 32.6475 15.3119L22.8308 7.56188C25.8292 4.94251 23.9632 0 19.9969 0C16.0309 0 14.1644 4.94235 17.163 7.56188L7.3463 15.3119C6.47391 16.0007 6.96104 17.4118 8.07532 17.4118H12.389V37.4902H15.0557V28.7843C15.0557 28.1349 15.5828 27.6078 16.2322 27.6078H23.7616C24.411 27.6078 24.9381 28.1349 24.9381 28.7843V37.4902H27.6047V17.4118H31.9185ZM23.7616 22.4314H16.2322C15.5828 22.4314 15.0557 21.9043 15.0557 21.2549C15.0557 20.6055 15.5828 20.0784 16.2322 20.0784H23.7616C24.411 20.0784 24.9381 20.6055 24.9381 21.2549C24.9381 21.9043 24.411 22.4314 23.7616 22.4314Z",
    fill: "#D2AE5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledSeventeen);
export default __webpack_public_path__ + "static/media/al-filled-seventeen.a9b7bebf3ec8b12c6add36151677dc3c.svg";
export { ForwardRef as ReactComponent };